import { FC } from 'react';
import qs from 'query-string';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? '';
const IS_PROD = process.env.NODE_ENV === 'production';

export const GTMNoScript: FC = () =>
  IS_PROD ? (
    <iframe
      className="hidden"
      title="gtm-noscript"
      aria-hidden={true}
      src={`https://www.googletagmanager.com/ns.html?${qs.stringify({
        id: GTM_ID,
      })}`}
      height={0}
      width={0}
    />
  ) : null;
